<template>
  <form autocomplete="off">
    <div class="message">{{ $t('illion.multipleAccountsMessage') }}</div>

    <input-select
      id="account-input-select"
      name="account-input-select"
      :value="selectedAccount"
      @change="onChange"
      :options="accounts"
      v-validation:closed="['required']"
    >
      <template #label>{{ $t('illion.chooseAccountLabel') }}</template>
    </input-select>

    <slot name="error-banner" />
  </form>
</template>
<script>
export default {
  name: 'AccountSelection',
  props: {
    accounts: {
      type: Array,
      default: () => [],
    },
    selectedAccount: {
      type: String,
      default: '',
    },
  },
  methods: {
    onChange(accountId) {
      this.$emit('accountSelected', accountId);
    },
  },
};
</script>
<style lang="sass" scoped>
.message
  font-weight: bold
  margin-top: baseunit(1.6)

.brandBanner
  margin: baseunit(1.6) 0
  align-items: center
</style>
